import axios, { InternalAxiosRequestConfig } from 'axios';
import { getToken } from './auth-token-utils/cookie';

const baseURL = process.env.REACT_APP_BASE_URL || '';

const AxiosInstance = axios.create({
  baseURL,
});

// const username = process.env.REACT_APP_USERNAME;
// const password = process.env.REACT_APP_PASSWORD;
// const users = btoa(`${username}:${password}`);

AxiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getToken();
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      if (config.headers) {
        config.headers['Content-Type'] = 'multipart/form-data';
      }
    } else {
      // Default Content-Type for JSON requests
      if (config.headers) {
        config.headers['Content-Type'] = 'application/json';
      }
    }
    // config.headers['users'] = `Basic ${users}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;

    if (response && response.status === 401) {
      localStorage.clear();
      window.location.replace('/');
    }
    return Promise.reject(error);
  },
);

export default AxiosInstance;
